"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";
import { useRouter } from "next/navigation";
import { SiteHeader } from "@/components/site-chrome";
import { usePrefs } from "@/components/prefs-provider";

function safeNextPath(next: string | null) {
  if (!next || !next.startsWith("/") || next.startsWith("//")) return "/dashboard";
  if (next === "/login" || next === "/register" || next.startsWith("/api")) return "/dashboard";
  return next;
}

export default function LoginPage() {
  const router = useRouter();
  const { t } = usePrefs();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);
    setError("");
    const fd = new FormData(e.currentTarget);
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: fd.get("email"),
        password: fd.get("password"),
      }),
    });
    const data = await res.json();
    setLoading(false);
    if (!res.ok) {
      setError(data.error || t.auth.loginFailed);
      return;
    }
    const next = new URLSearchParams(window.location.search).get("next");
    router.push(safeNextPath(next));
  }

  return (
    <div className="hero-mesh min-h-screen">
      <SiteHeader solid />
      <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4 py-24">
        <p className="font-display text-3xl font-bold">{t.auth.welcome}</p>
        <p className="mt-2 text-[var(--ink-soft)]">{t.auth.loginLead}</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.email}</label>
            <input name="email" type="email" required className="input" />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.password}</label>
            <input name="password" type="password" required className="input" />
          </div>
          {error && <p className="text-sm text-[var(--alert)]">{error}</p>}
          <button disabled={loading} className="btn-primary w-full" type="submit">
            {loading ? t.auth.signingIn : t.auth.login}
          </button>
        </form>
        <p className="mt-6 text-sm text-[var(--ink-soft)]">
          {t.auth.newHere}{" "}
          <Link href="/register" className="font-semibold text-[var(--teal)]">
            {t.auth.createAccount}
          </Link>
        </p>
      </main>
    </div>
  );
}
